/**
 * Generated runtime TestId mirror for frontend/src/pages/Parties.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const PartiesTestIds = {
  btnNewUser: "btn-new-user",
  colCreatedAt: "col-created-at",
  colName: "col-name",
  colType: "col-type",
  partiesList: "parties-list",
  partyRow: "party-row",
  linkPartyDetail: (party_id: string) => `link-party-detail-${party_id}`,
  linkPartyDetailPrefix: () => "link-party-detail-" as TestIdPrefix
} as const;
